export const iconFontAwesomeScienceVial = (
	<i className="fa-solid fa-vial"></i>
);
